import type { AlbumKind } from "@/lib/lutely-api/gen/dtos";
import type { IconType } from "react-icons";
import { MdMusicNote, MdOutlineLibraryMusic } from "react-icons/md";

export const RELEASE_KIND_OPTIONS: {
  kind: AlbumKind;
  title: string;
  description: string;
  Icon: IconType;
}[] = [
  {
    kind: "SINGLE",
    title: "Single",
    description: "One track. Add versions to make it a Super Single.",
    Icon: MdMusicNote,
  },
  {
    kind: "ALBUM",
    title: "Album",
    description: "Two or more tracks.",
    Icon: MdOutlineLibraryMusic,
  },
];
